import { Component, OnInit, ViewChild,EventEmitter, Inject,ViewChildren,QueryList  } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { OrganismModel } from '../../partners/organisms/organism.model';
import { MasterService } from 'src/app/masters/master.service';
import { AddContactComponent } from '../../masters/add-contact/add-contact.component';
import { AddAddressComponent } from '../../masters/add-address/add-address.component';
import { SelectItem } from 'primeng/api';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PatientService } from '../patient.service';
import * as moment from 'moment';
import * as CommonConstants from '../../utils/common.constants';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/common/loader.service';
import { FileUploadModule } from 'primeng/fileupload';
import { PageScrollService } from 'ngx-page-scroll-core';
import { DOCUMENT } from '@angular/common'
import { SharedService } from 'src/app/utils/shared.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { SearchCountryField, TooltipLabel, CountryISO } from 'ngx-intl-tel-input';
import { IntlTelNumberComponent } from '../../common/intl-tel-number/intl-tel-number.component';
import { FileUploadComponent } from 'src/app/file-upload/file-upload.component';

@Component({
  selector: 'app-add-patient',
  templateUrl: './add-patient.component.html',
  styleUrls: ['./add-patient.component.scss']
})
export class AddPatientComponent implements OnInit {
  separateDialCode = true;
	SearchCountryField = SearchCountryField;
	TooltipLabel = TooltipLabel;
	CountryISO = CountryISO;
	preferredCountries: CountryISO[] = [CountryISO.France, CountryISO.SouthAfrica];
  addPatientTitle = true;
  editPatientTitle;
  patientForm: FormGroup;
  organisms: OrganismModel[];
  townList: any = [];
  countryList: any = [];
  rowData: any[];
  cities1: SelectItem[];
  selectedCities: FormControl;
  civilityList;
  nationalityList;
  partnerList;
  genderList;
  maritalStatusList=[];
  groupList;
  divisionList;
  classList;
  professionList;
  submitted = false;
  patieId;
  administrationList;
  financialList;
  logisticList;
  logisticsType = CommonConstants.PARTNER_LOGISTICS_TYPE;
  financialType = CommonConstants.PARTNER_FINANCIAL_TYPE;
  administrationType = CommonConstants.PARTNER_ADMINISTRATION_TYPE;
  partnerType: number = CommonConstants.PATIENT;
  selectedAdminstrationItems = [];
  selectedFinancialItems = [];
  selectedLogisticItems = [];
  patientLogisticList=[];
  patientAdminstrationList=[];
  patientFinancialList=[];
  patientLogisticFullList=[];
  patientFinanciaFulllList=[];
  patientAddressList=[];
  patientContactList=[];
  medicalFiles=[];
  medicalDocuments=[];
  pagrpId;
  civilCode;
  gendeCode;
  maritalStatusCode;
  dropdownSettings: IDropdownSettings;
  url = '';
  adminAdded=false;
  finAdded=false;
  logisticAdded=false;
  PARAM_KEY=[CommonConstants.MARITAL_STATUS,CommonConstants.GENDER];
  PARAM_CODE_KEY=[CommonConstants.DOCUMENT_TYPE]
  uploadedFiles: any[] = [];
  masterValues=[];
  masterCodes;
  documentTypes;
  uplo: File;
  selectedMedfiId;
  @ViewChild(AddContactComponent, { static: true }) patientContact: AddContactComponent;
  @ViewChild(AddAddressComponent, { static: true }) patientAddress: AddAddressComponent;
  @ViewChildren(IntlTelNumberComponent) phoneNos: QueryList<IntlTelNumberComponent>
  @ViewChild(FileUploadComponent, { static: true }) fileUpload: FileUploadComponent;
  townListByCountry: any;
  constructor(private masterService: MasterService, private formBuilder: FormBuilder, private modalService: NgbModal
    , private patientService: PatientService, private sharedService: SharedService,private router:Router,private toastrService:ToastrService,private loaderService:LoaderService, private pageScrollService: PageScrollService, @Inject(DOCUMENT) private document: any) {

    this.getFromGroup();
   
  }

  ngOnInit() {
    //this.patientAddress.addressList=this.patientAddressList;
   // this.patientContact.employeeList=this.patientContactList;
   this.patientAddress
    this.loadMasterData();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'partnerid',
      textField: 'partnername',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      //itemsShowLimit: 3,
      allowSearchFilter: true
    };


    this.pageScrollService.scroll({
      document: this.document,
      scrollTarget: '.theEnd',
    });

  }
  /**
  * Declare form group
  *  
  */
  private getFromGroup() {
    this.patientForm = this.formBuilder.group({
      'patieId': new FormControl(),
      'patientNumber': new FormControl(),
      'orgsmId': ['', Validators.required],
      'cotryIdResidence': new FormControl(),
      'civilCode': ['', Validators.required],
      'cotryIdNationality': new FormControl(),
      'persoVaFirstnameEn': ['', Validators.required],
      'persoVaLastnameEn': ['', Validators.required],
      'maritalStatus': new FormControl(),
      'patieNuNumberChildren': new FormControl(),
      'gendeCode': ['', Validators.required],
      'patieNuNumberSpouse': new FormControl(),
      'age': new FormControl(),
      'ageCategory': new FormControl(),
      'ageSubcategory': new FormControl(),
      'division': new FormControl(),
      'pagrpId': new FormControl(),
      'class': new FormControl(),
      'prfesId': new FormControl(),
      'patieVaPassportNumber': new FormControl(),
      'persoDtBirthDate': ['', Validators.required],
      'patieVaEmployment': ['', Validators.required],
      'persoVaEmail1': ['', Validators.email],
      'persoVaWorkFax': new FormControl(),
      'persoVaHomePhone': new FormControl(),
      'persoVaWorkPhone': new FormControl(),
      'persoVaMobilePhone1': new FormControl(),
      'persoVaMobilePhone2': new FormControl(),
      'address': new FormControl(),
      'cotryId': new FormControl(),
      'townId': new FormControl(),
      'postalCode': new FormControl(),
      'referralName': new FormControl(),
      'mobileNo': new FormControl(),
      'financials': new FormControl(),
      'administrations': new FormControl(),
      'logistics': new FormControl(),
      'patieNationalIdNum':new FormControl()
      /*  'networkId': this.formBuilder.control(null, Validators.required) */
    })
  }

  get f() { return this.patientForm.controls; }

  loadMasterData() {

    this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
      if (response && response['result']) {
        this.masterValues = response['result'];
        this.genderList=this.masterValues.filter(master => master.paramKey === CommonConstants.GENDER);
        this.maritalStatusList=this.masterValues.filter(master => master.paramKey === CommonConstants.MARITAL_STATUS);
      }
    });
    this.masterService.getMastersCodesByParamKey(this.PARAM_CODE_KEY).subscribe(response => {
      if (response && response['result']) {
        this.masterCodes = response['result'];
        this.documentTypes = this.masterCodes.filter(master => master.paramKey === CommonConstants.DOCUMENT_TYPE);
      }
    });
    this.masterService.getOrganisms().subscribe(response => {
      if (response && response['result']) {
        this.organisms = response['result'];
      }
    });
    this.masterService.getCountry().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.countryList = response['result'];
      }
    });


    this.masterService.getTown().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.townList = response['result'];
      }
    });

    this.masterService.getPartners();
    this.masterService.partnerList.subscribe(value => {
      this.partnerList = value;
      this.filterPartnerTypes()
    });

    this.masterService.getCivilityList();
    this.masterService.civilityList.subscribe(value => {
      this.civilityList = value;
    });

    /* this.masterService.getNationalitList();
    this.masterService.nationailityList.subscribe(value => {
      this.nationalityList = value;
    });
 */
    this.masterService.getGroupList();
    this.masterService.groupList.subscribe(value => {
      this.groupList = value;
    });

    this.masterService.getCountryList();
    this.masterService.countryList.subscribe(value => {
      this.countryList = value;
      this.nationalityList = value;
    });

   /*  let masterEnum = {
      masterShName: 'DIVISION',
      master: {}
    }
    this.masterService.searchMaster(masterEnum).subscribe(response => {
      this.divisionList = response['result'];
    })
    masterEnum = {
      masterShName: 'CLASS',
      master: {}
    }
    this.masterService.searchMaster(masterEnum).subscribe(response => {
      this.classList = response['result'];
    }) */
    let masterEnum = {
      masterShName: 'PROFESSION',
      master: {}
    }
    this.masterService.searchMaster(masterEnum).subscribe(response => {
      this.professionList = response['result'];
    })
    
  }

  addDocModal(addDoc) {
    this.modalService.open(addDoc, { size: 'lg', container: '.page-content' });
/*     (this.modalContent, { size: 'lg', container: '.page-content' }); */
  }

  filterPartnerTypes() {
    if (!this.partnerList) {
      this.masterService.getPartners();
      this.masterService.partnerList.subscribe(value => {
        this.partnerList = value;
        this.setPartners();
      })
    } else {
      this.setPartners();
    }

  }

  onItemSelect(item: any) {
  }

  setPartners() {
    this.administrationList = this.partnerList.filter(item => item.partnertypeid === CommonConstants.PARTNER_ADMINISTRATION_TYPE);
    this.financialList = this.partnerList.filter(item => item.partnertypeid === CommonConstants.PARTNER_FINANCIAL_TYPE);
    this.logisticList = this.partnerList.filter(item => item.partnertypeid === CommonConstants.PARTNER_LOGISTICS_TYPE);
  }
  savePatient() {
    this.submitted = true;
     if (this.patientForm.invalid) {
      swal.fire("Error","Please Fill all Mandatory Fields","error");
      return;
    } 
    this.patientForm.patchValue({persoDtBirthDate:moment(this.patientForm.value.persoDtBirthDate,"DD-MM-YYYY").format("DD-MM-YYYY")})
    let jsonData=this.patientForm.value;
    this.phoneNos.forEach(phone => {
      jsonData[phone.type]=phone.setPhoneNumberfrmInternation();
  }) 
    this.loaderService.display(true);
    this.patientService.savePatient(jsonData).subscribe(res => {
      this.loaderService.display(false);
      if (res['result'] && res['code'] === "0") {
        let patient= res['result'];
        this.patieId = res['result'].patieId;
          this.patientForm.patchValue({ patieId: this.patieId});
          if(this.url!=null && this.patieId!=null){
            this.saveImage(this.url,this.patieId);
          }
          this.toastrService.success('Patient Registrations Details updated Successfully');
      } else {
          this.toastrService.error(res['message'], 'Error');
        } 
    })
  }
saveImage(url:string,patId:number){
  let imageJson={};
  //console.log(url);
  let imgData=url.split(",");
  imageJson["image"]=imgData[1];
  imageJson["partnerId"]=patId;
  imageJson["partnerType"]=CommonConstants.PATIENT;
  imageJson["partnerTypeDesc"]="Patient";
  this.masterService.saveImage(imageJson).subscribe(res => {
    if (res['result'] && res['code'] === "0") {
      this.toastrService.success('Patient image updated Successfully');
    } else {
      this.toastrService.error('Patient image not updated Successfully');
    }
  })
}
  saveAdministrations() {
    let i = 1;
    let jsonData;
    jsonData = this.selectedAdminstrationItems.map(item => ({
      adminId: item.partnerid,
      patieId: this.f.patieId.value
    }));
    this.loaderService.display(true);
    this.patientService.saveAdministrations(jsonData).subscribe(res => {
      if (res['code'] === "0") {
        this.loaderService.display(false);
        this.adminAdded= true;
        for(let admin of this.selectedAdminstrationItems){
          this.patientAdminstrationList.push(admin);
         }
         this.selectedAdminstrationItems=[];
        this.toastrService.success('Administrations Added Succesfully');
      }
      else{
        this.loaderService.display(false);
        this.toastrService.error('Error While Adding Administrations');
       }
    })
  }

  saveFinancials(data) {
    let i = 1;
    let jsonData;
    jsonData = this.selectedFinancialItems.map(item => ({
      finanId: item.partnerid,
      patieId: this.f.patieId.value,
      medfiId:this.selectedMedfiId
    }));
    this.loaderService.display(true);
    this.patientService.saveFinancials(jsonData).subscribe(res => {
      if (res['code'] === "0") {
        this.loaderService.display(false);
       this.finAdded= true;
       for(let fin of this.selectedFinancialItems){
        this.patientFinancialList.push(fin);
       }
       this.toastrService.success('Financials Added Succesfully');
       this.selectedFinancialItems=[];
    }
    else{
      this.loaderService.display(false);
      this.toastrService.error('Error While Adding Financials');
     }
    })
  }

  saveLogistics(data) {
    let i = 1;
    let jsonData;
    jsonData = this.selectedLogisticItems.map(item => ({
      logistId: item.partnerid,
      patieId: this.f.patieId.value,
      medfiId:this.selectedMedfiId
    }));
    this.loaderService.display(true);
    this.patientService.saveLogistics(jsonData).subscribe(res => {
    if (res['code'] === "0") {
      this.loaderService.display(false);
       this.logisticAdded= true;
       for(let logistic of this.selectedLogisticItems){
        this.patientLogisticList.push(logistic);
       }
       this.toastrService.success('Logistics Added Succesfully');
       this.selectedLogisticItems=[];
   }else{
    this.loaderService.display(false);
    this.toastrService.error('Error While Saving Logistic');
   }
    })
  }
  removeItem(pId,type,index){
    switch(type){
      case CommonConstants.PARTNER_ADMINISTRATION_TYPE:
        this.patientAdminstrationList.splice(index);
        break;
        case CommonConstants.PARTNER_FINANCIAL_TYPE:
           this.patientFinancialList.splice(index);
          case CommonConstants.PARTNER_LOGISTICS_TYPE:
            this.patientLogisticList.splice(index);
            break;
    }
        this.patientService.deletePatientPartnerType(this.f.patieId.value, pId, type).subscribe(res => {
          if(res['result'] && res['result']===1){
            this.toastrService.success('Removed Successfully');
          }else{
            this.toastrService.error('Error Occured While removing the record');
          }
        })
  }

  deleteItem(data, partnerType) {
  /*   if (data) {
      if (Array.isArray(data)) {
        switch (partnerType) {
          case CommonConstants.PARTNER_ADMINISTRATION_TYPE:
            data = this.administrationList;
            break;
          case CommonConstants.PARTNER_FINANCIAL_TYPE:
            data = this.financialList;
          case CommonConstants.PARTNER_LOGISTICS_TYPE:
            data = this.logisticList;
            break;
        }
        for (let value of data) {
          this.patientService.deletePatientPartnerType(123, value.partnerid, partnerType).subscribe(res => {
          })
        }
      } else {
        this.patientService.deletePatientPartnerType(123, data.partnerid, partnerType).subscribe(res => {
          if (res) {
          }
        })
      }
    } */
  }
getAgeCategory(){
  let pAge;
  let pAgeCat;
  let pAgeSubCat;
if(this.f.persoDtBirthDate.value){
  let dob=moment(this.f.persoDtBirthDate.value, "DD-MM-YYYY HH:mm").toDate();
  let today = new Date();
  let differenceInTime = today.getTime() - dob.getTime();
  // To calculate the no. of days between two dates
  let differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24)); 
  let ageInMonths=differenceInDays/31;
  if (ageInMonths < 2) {
    pAge = Math.round(ageInMonths) + " Months";
    pAgeCat = "Baby";
    pAgeSubCat = "New Born or Young Baby";
  } else {
    let age=today.getFullYear() - dob.getFullYear();
  if (ageInMonths <12) {
    pAge = Math.round(ageInMonths) + " Months";
  } else {
    pAge = age + " Years"
  }
  if (age <= 2) {
    pAgeCat= "Baby";
    pAgeSubCat = "Toddler or Older Baby";
  } else if (age <= 4) {
     pAge= "Infant";
    pAgeSubCat = "Preschool Child";
  } else if (age <= 10) {
    pAgeCat = "Infant";
    pAgeSubCat = "School Child"
  } else if (age <= 16) {
    pAgeCat = "Infant";
    pAgeSubCat = "Adolescent";
  } else if (age <= 19) {
    pAgeCat = "Adult";
    pAgeSubCat = "Post Adolescent";
  } else if (age <= 39) {
    pAgeCat = "Adult";
    pAgeSubCat = "Young Adult";
  } else if (age <= 59) {
    pAgeCat = "Adult";
    pAgeSubCat = "Actif Adult";
  } else if (age <= 75) {
    pAgeCat = "Adult";
    pAgeSubCat = "Old People";
  } else {
    pAgeCat = "Adult";
    pAgeSubCat = "Very Old People";
  }
  }
  this.patientForm.patchValue({
    'age': pAge,
    'ageCategory': pAgeCat,
    'ageSubcategory': pAgeSubCat,
  })
}
}

  addProfilePic(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event) => { // called once readAsDataURL is completed
        this.url = <string>event.target["result"];
      }
    }
  }
  public deleteProfilePic(){
    this.url = null;
  }
  saveAddMapping(addressId) {
    let jsonData = {
      paadrId: addressId,
      patieId: this.f.patieId.value,
      staRecCode:'A',
      adtypCode:'2'
    }
    let addressIp=[];
    addressIp.push(jsonData);
    this.patientService.savePatientAddress(addressIp).subscribe(res => {
    if (res['result'] && res['code']==="0") {
       this.toastrService.success('Address Added Succesfully');
     }
    })
  }
  saveContactMapping(contactId) {
    let jsonData = {
      paadrId: contactId,
      patieId: this.f.patieId.value,
      staRecCode:'A',
      adtypCode:'2'
    }
    let contactIp=[];
    contactIp.push(jsonData);
    this.patientService.savePatientContact(contactIp).subscribe(res => {
    if (res['result'] && res['code']==="0") {
       this.toastrService.success('Contact Added Succesfully');
     }
    })
  }
/*   public uploader: FileUploader = new FileUploader({
    url:'http://localhost:4200/fileupload/',
    disableMultipart : true,
    autoUpload: false,
    method: 'post',
    itemAlias: 'attachment',
    allowedFileType: ['image', 'pdf']


    }); */

  public onFileSelected(event: EventEmitter<File[]>) {
    const file: File = event[0];

  }

  onUpload(event) {
    for(let file of event.files) {
        this.uploadedFiles.push(file);
        this.uplo = file;
    }
    this.upload();
}
upload(){

  const formData: FormData = new FormData();
  let file: File = null;
  file = this.uploadedFiles[0];
  formData.append("file",file,file.name);
 /* for (let file of this.uploadedFiles) {
   formData.append("file",file,file.name);
  }  */


   this.patientService.postFile(formData).subscribe(data => {
    alert('Success');
  }, error => {
  });
}
resetForm(){
  this.patientForm.reset();
}
onMedicalFileRowSelect(event){
  this.sharedService.nextMedicalFiledId(event.data.medfiId);
  this.sharedService.medicalFileStatus(event.data.status);
  localStorage.setItem(CommonConstants.FILE_STATUS, event.data.status);
      this.router.navigate(['/addMedicalFiles']);
      this.router.navigate(["/addMedicalFiles"], {
        state: {
          medicalFileDtls:event.data
        }
      });
}
addNewMedicalFile(){
  this.router.navigate(["/addMedicalFiles"], {
    state: {
      patientDtls:this.patientForm.value
    }
  });
}
onChangeCountry(event){
  if(event && event.cotryId){
    this.townListByCountry=this.townList.filter(town => town.cotryId===event.cotryId);
    let country  =this.countryList.filter(type => type.cotryId == event.cotryId);
    this.phoneNos.forEach(phone => {
      phone.selectedCountry=country[0].cotryCode;
   })
  }else{
    this.townListByCountry=this.townList;
    this.phoneNos.forEach(phone => {
      phone.selectedCountry=CountryISO.France;
   })
  }
 

}
loadFinanceAndLogsitic(event){
  this.patientLogisticList =[];
  this.patientFinancialList = [];
this.selectedMedfiId=event.data.medfiId;
this.patientService.getLogistics(this.selectedMedfiId).subscribe(response => {
  if (response['code'] == 'S0000') {
    let responseObj = response["result"];
    responseObj =  responseObj.map(item =>({
      partnerid: item.logistId,
      partnername : this.logisticList.find(pItem => pItem.partnerid == item.logistId).partnername,
    }))
    this.selectedLogisticItems = [];
  this.patientLogisticList= responseObj;
  }
});
this.patientService.getFinancials(this.selectedMedfiId).subscribe(response => {
  if (response['code'] == 'S0000') {
    let responseObj = response["result"];
    responseObj =  responseObj.map(item =>({
      partnerid: item.finanId,
      partnername : this.financialList.find(pItem => pItem.partnerid == item.finanId).partnername,
    }))
    this.selectedFinancialItems=[];
    this.patientFinancialList = responseObj;
  }
});
}
/* changePreferredCountries() {
  this.preferredCountries = [CountryISO.India, CountryISO.Canada];
  const controls = this.patientForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
            console.log(name);
            console.log(controls[name]);
        }
    }
} */
}
